import {
  useSearchParams,
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import "../NewHome/HomePage.scss";
import FooterSection from "../NewHome/sections/FooterSection";
import TopBar from "../NewHome/sections/TopBar";
import FAQItem from "./FAQItem";

export default function FAQPage() {
  const { t } = useTranslation(["page"]);
  const [searchParams, setSearchParams] = useSearchParams();
  const ver = searchParams.get("ver") || "1";
  const lang = searchParams.get("lang");

  return (
    <div className="page-content FAQPage">{FAQItem("question", "answer")}</div>
  );
}
